var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 68C52.5665 68 68 52.5667 68 34C68 15.4 52.5332 0 33.9666 0C15.3665 0 0 15.4 0 34C0 52.5667 15.3999 68 33.9999 68ZM25.2999 42.3001C17.0332 34.0667 11.7666 23.5666 17.9999 17.3334C18.3665 16.9666 18.7666 16.5999 19.1333 16.2333C21.0332 14.4333 22.8666 14.5333 24.4999 16.8333L28.8332 22.9999C30.2998 25.1333 29.9332 26.3334 28.3666 28.0001L26.9998 29.5001C26.4999 29.9666 26.6999 30.6 26.9333 31C27.5666 32.2 29.3666 34.3334 31.2998 36.2667C33.2998 38.2667 35.3332 39.9667 36.5998 40.6667C37.0666 40.9333 37.7332 41 38.1665 40.6L39.5998 39.2334C41.1998 37.6666 42.4999 37.2667 44.5665 38.7333C47.4331 40.7667 49.1665 41.9667 50.8665 43.1334C52.9664 44.6667 53.4665 46.5668 51.3332 48.5C50.9665 48.8667 50.6331 49.2667 50.2665 49.6334C44.0332 55.8334 33.5665 50.5666 25.2999 42.3001Z",
    fill: "#FFDFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.df4b80635fde615e784d8b0178b9f866.svg";
export { ForwardRef as ReactComponent };